var React = require('react');

function ArrowRight (props) {
    return React.createElement("svg",props,React.createElement("g",{"fill":"none","fillRule":"evenodd","stroke":"currentColor","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"2.5"},React.createElement("path",{"d":"M2 9h14M9 2l7 7-7 7"})));
}

ArrowRight.defaultProps = {"width":"18","height":"18","viewBox":"0 0 18 18"};

module.exports = ArrowRight;

ArrowRight.default = ArrowRight;
